import React, { useState } from 'react'
import MainBox from '../MainBox/index'
import PassResetEmail from '../passReset/index'
import CodeInput from '../CodeInput/index'
import RegisterScreen from '../Register/index'
import { Container } from './style'

interface LoginInfo {
  email: string
  password: string
}

const LoginScreen = () => {
  const [page, setPage] = useState<string>('Main')

  const [userlogin, setUserlogin] = useState<LoginInfo>({
    email: '',
    password: '',
  })

  return (
    <Container>
      {page === 'Main' ? (
        <MainBox setUserlogin={setUserlogin} setPage={setPage} />
      ) : null}

      {page === 'PassReset' ? <PassResetEmail setPage={setPage} /> : null}

      {page === 'CodeInput' ? <CodeInput setPage={setPage} /> : null}

      {page === 'Register' ? <RegisterScreen setPage={setPage} /> : null}
    </Container>
  )
}

export default LoginScreen
